import { createSvgIcon } from "@mui/material";

const TicketDesk = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 9C2.79565 9 3.55871 9.31607 4.12132 9.87868C4.68393 10.4413 5 11.2044 5 12C5 12.7956 4.68393 13.5587 4.12132 14.1213C3.55871 14.6839 2.79565 15 2 15V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H20C20.5304 19 21.0391 18.7893 21.4142 18.4142C21.7893 18.0391 22 17.5304 22 17V15C21.2044 15 20.4413 14.6839 19.8787 14.1213C19.3161 13.5587 19 12.7956 19 12C19 11.2044 19.3161 10.4413 19.8787 9.87868C20.4413 9.31607 21.2044 9 22 9V7C22 6.46957 21.7893 5.96086 21.4142 5.58579C21.0391 5.21071 20.5304 5 20 5H4C3.46957 5 2.96086 5.21071 2.58579 5.58579C2.21071 5.96086 2 6.46957 2 7V9Z"
      fill="currentColor"
    />
    <path
      d="M12.8333 14.083H9.08325"
      stroke="white"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9167 9.91699H11.1667"
      stroke="white"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0833 15.333C14.7736 15.333 15.3333 14.7734 15.3333 14.083C15.3333 13.3927 14.7736 12.833 14.0833 12.833C13.3929 12.833 12.8333 13.3927 12.8333 14.083C12.8333 14.7734 13.3929 15.333 14.0833 15.333Z"
      stroke="white"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91675 11.167C10.6071 11.167 11.1667 10.6073 11.1667 9.91699C11.1667 9.22664 10.6071 8.66699 9.91675 8.66699C9.22639 8.66699 8.66675 9.22664 8.66675 9.91699C8.66675 10.6073 9.22639 11.167 9.91675 11.167Z"
      stroke="white"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Ticket Desk",
);

export default TicketDesk;
